import { version } from './../package.json'

import { createApp } from 'vue'
import App from './App.vue'
import './worker.js'

// scss
import './styles/global.scss'

// Plugins
import { registerPlugins } from '@/plugins'

// Directives
import { registerDirectives } from './directives'
import globalMixins from './mixins/global.ts'

// Components
import { registerComponents } from './components'

import axios from './api/axios.js'
import { timeoutSwal } from './utils/swal.ts'
import { initializeI18n } from './plugins/i18n.js'

import { useAuthStore } from './store/auth'

await initializeI18n()

const app = createApp(App)

if (navigator.userAgent.includes('OrquizDesktop')) {
  window.top.postMessage(
    {
      source: 'orquiz',
      action: 'gameStarted',
      game: {},
    },
    '*'
  )
}

console.info(`vue version:  ${app.version}`)
console.info('app version: ' + version)

// register plugins
await registerPlugins(app)

useAuthStore().checkLogin()

app.mixin(globalMixins)

// register directives
registerDirectives(app)

// register components
registerComponents(app)

app.mount('#app')

app.config.errorHandler = async (err, instance, info) => {
  // alert('Global error handler: ' + err)
  console.log('Component instance:', instance)
  if (err) {
    console.error('Global error handler:', err)
  }
  if (info) {
    console.info('Info:', info)
  }

  // Custom logic, e.g., report to error tracking service
  // sendToMonitoringService(err, info)
  const title = err.customError || ''
  const locale = app.config.globalProperties.$i18n?.locale

  timeoutSwal({
    icon: 'error',
    title,
    lang: locale,
  })
  await axios.post('/user/err', {
    err: { message: err.message, stack: err.stack },
    url: window.location.href,
  })
}
